export default {
  init() {

  },

  finalize() {

    if($('.image-carousel').length !== 0) {

      var slider = $('.image-carousel').owlCarousel({
        dots: true,
        items: 1,
      });

      $('[data-action]').click(function () {
        var action = $(this).data('action');
        slider.trigger(`${action}.owl.carousel`);
      })

    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/template-flexi-default.js